<template>
  <div>
    <hr class="mb-0" />
    <div class="max-resolution container">
      <div class="row">
        <div class="col-sm-3 pt-5 bg-default pr-0" style="min-height: 100vh">
          <div class="main">
            <aside>
              <div class="sidebar left">
                <ul class="list-sidebar bg-default">
                  <li>
                    <a
                      href="#"
                      data-toggle="collapse"
                      data-target="#dashboard"
                      class="collapsed active"
                      id="getting_started"
                    >
                      <span class="nav-label"> Home </span>
                      <span class="fa fa-chevron-down pull-right"></span>
                    </a>
                    <ul class="sub-menu collapse" id="dashboard">
                      <li class="active">
                        <a
                          :class="check_currrent_page('docs_home')"
                          href="javascript: void(0)"
                          @click="sendView('docs_home')"
                          >Getting Started</a
                        >
                      </li>
                      <!-- <li><a href="javascript: void(0)">Getting Started</a></li> -->
                    </ul>
                  </li>
                  <!-- <li>
                    <a
                      href="#"
                      data-toggle="collapse"
                      data-target="#products"
                      class="collapsed active"
                      id="admin_guide"
                    >
                      <span class="nav-label">Admin Guide</span>
                      <span class="fa fa-chevron-down pull-right"></span>
                    </a>
                    <ul class="sub-menu collapse" id="products">
                      <li><a href="#">General</a></li>
                    </ul>
                  </li> -->
                  <li>
                    <a
                      href="#"
                      data-toggle="collapse"
                      data-target="#tables"
                      class="collapsed active"
                      id="sdk_apis"
                    >
                      <span class="nav-label">SDK and APIs</span
                      ><span class="fa fa-chevron-down pull-right"></span
                    ></a>
                    <ul class="sub-menu collapse" id="tables">
                      <li>
                        <a
                          href="javascript: void(0)"
                          @click="sendView('ios')"
                          :class="check_currrent_page('ios')"
                          >iOS</a
                        >
                      </li>
                      <li>
                        <a
                          href="javascript: void(0)"
                          :class="check_currrent_page('android')"
                          @click="sendView('android')"
                          >Andoid</a
                        >
                      </li>
                      <li>
                        <a
                          href="javascript: void(0)"
                          :class="check_currrent_page('docs_web')"
                          @click="sendView('docs_web')"
                          >Web</a
                        >
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a
                      href="#"
                      data-toggle="collapse"
                      data-target="#e-commerce"
                      class="collapsed active"
                      id="commerce_platform"
                    >
                      <span class="nav-label"
                        >Commerce Platform Integration</span
                      ><span class="fa fa-chevron-down pull-right"></span
                    ></a>
                    <ul class="sub-menu collapse" id="e-commerce">
                      <li>
                        <a
                          href="javascript: void(0)"
                          @click="sendView('shopify')"
                          :class="check_currrent_page('shopify')"
                          >Shopify</a
                        >
                      </li>
                      <li>
                        <a
                          href="javascript: void(0)"
                          @click="sendView('squarespace')"
                          :class="check_currrent_page('squarespace')"
                          >SquareSpace</a
                        >
                      </li>
                      <li>
                        <a
                          href="javascript: void(0)"
                          @click="sendView('weebly')"
                          :class="check_currrent_page('weebly')"
                          >Weebly</a
                        >
                      </li>
                      <li>
                        <a
                          href="javascript: void(0)"
                          @click="sendView('wix')"
                          :class="check_currrent_page('wix')"
                          >Wix</a
                        >
                      </li>
                      <li>
                        <a
                          href="javascript: void(0)"
                          @click="sendView('wordpress')"
                          :class="check_currrent_page('wordpress')"
                          >Wordpress / Woocommerce</a
                        >
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a
                      href="#"
                      data-toggle="collapse"
                      data-target="#messaging"
                      class="collapsed active"
                      id="messaging_platform"
                    >
                      <span class="nav-label"
                        >Messaging Platform Integration</span
                      ><span class="fa fa-chevron-down pull-right"></span
                    ></a>
                    <ul class="sub-menu collapse" id="messaging">
                      <li>
                        <a
                          href="javascript: void(0)"
                          @click="sendView('slack')"
                          :class="check_currrent_page('ios')"
                          >Slack</a
                        >
                      </li>
                      <li>
                        <a
                          @click="sendView('ms_teams')"
                          href="javascript: void(0)"
                          :class="check_currrent_page('ios')"
                          >MS Teams</a
                        >
                      </li>
                      <li>
                        <a
                          href="javascript: void(0)"
                          @click="sendView('messenger')"
                          :class="check_currrent_page('ios')"
                          >Facebook Messenger</a
                        >
                      </li>
                      <li>
                        <a
                          href="javascript: void(0)"
                          @click="sendView('telegram')"
                          :class="check_currrent_page('ios')"
                          >Telegram</a
                        >
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </aside>
          </div>
        </div>
        <div class="col-sm-9 documentation-main">
        <zoom-center-transition :duration="200" mode="out-in">
          <router-view></router-view>
        </zoom-center-transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { ZoomCenterTransition } from "vue2-transitions";
export default {
  name: "Documentation",
  components: {
    ZoomCenterTransition,
  },
  data() {
    return {};
  },
  mounted() {
    $(".button-left").click(function () {
      $(".sidebar").toggleClass("fliph");
    });
    // $(".list-sidebar .collapse").on("show.bs.collapse", function (e) {
    //   console.log(e);
    //   /*eslint-disable*/
    //   // debugger;
    //   $(this)
    //     .prev()
    //     .find(".fa")
    //     .eq(1)
    //     .removeClass("fa-chevron-down")
    //     .addClass("fa-chevron-right");
    // });
    $(".list-sidebar .collapse").on("hide.bs.collapse", function () {
      setTimeout(() => {
        $(this)
          .prev()
          .find(".fa")
          // .eq(1)
          .removeClass("fa-chevron-up")
          .addClass("fa-chevron-down");
      }, 10);
    });
    $(".list-sidebar .collapse").on("show.bs.collapse", function () {
      setTimeout(() => {
        $(this)
          .prev()
          .find(".fa")
          // .eq(1)
          .removeClass("fa-chevron-down")
          .addClass("fa-chevron-up");
      }, 10);
    });
  },
  methods: {
    sendView(page_name) {
      this.$router.push({ name: page_name });
    },
    check_currrent_page(page_name) {
      if (this.$route.name == page_name) {
        return "current-active-page";
      } else {
        return "inactive-page";
      }
    },
  },
};
</script>

<style scoped>
li {
  border-bottom: 1px solid #e9e9e9;
}
.sub-menu li:last-child {
  border-bottom: 0;
}
.sub-menu {
  padding-left: 1rem !important;
}
.current-active-page {
  color: #283677 !important;
}
.fa {
  color: #434242;
}
.dropdown-toggle::after {
  display: none;
}
.sidebar {
  /* width: 220px; */
  background-color: #f9fcff;
  transition: all 0.5s ease-in-out;
}
.bg-default {
  background-color: #f9fcff;
}
.sidebar ul {
  list-style: none;
  margin: 0px;
  padding: 0px;
}
.sidebar li a,
.sidebar li a.collapsed.active {
  display: block;
  padding: 8px 12px;
  color: #313131;
  text-decoration: none;
}
.sidebar li a.active {
  background-color: #f9fcff;
  transition: all 0.5s ease-in-out;
}
.sidebar li a:hover {
  background-color: #f9fcff !important;
}
.sidebar li a i {
  padding-right: 5px;
}
.sidebar ul li .sub-menu li a {
  position: relative;
}
.sidebar ul li .sub-menu li a:before {
  font-family: FontAwesome;
  content: "\f0da";
  display: inline-block;
  padding-left: 0px;
  padding-right: 10px;
  vertical-align: middle;
}
.sidebar ul li .sub-menu li a:hover:after {
  content: "";
  position: absolute;
  left: -5px;
  top: 0;
  width: 5px;
  /* background-color: #111; */
  height: 100%;
}
.list-sidebar {
  font: normal normal normal 1.1rem/1.75rem Rubik;
}
.sidebar ul li .sub-menu li a:hover {
  background-color: #434242;
  padding-left: 20px;
  transition: all 0.5s ease-in-out;
}

.sidebar li a .nav-label,
.sidebar li a .nav-label + span {
  transition: all 0.5s ease-in-out;
}

.sidebar.fliph li a .nav-label,
.sidebar.fliph li a .nav-label + span {
  display: none;
  transition: all 0.5s ease-in-out;
}
.sidebar.fliph {
  width: 42px;
  transition: all 0.5s ease-in-out;
}

.sidebar.fliph li {
  position: relative;
}
.sidebar.fliph .sub-menu {
  position: absolute;
  left: 39px;
  top: 0;
  background-color: #222;
  width: 150px;
  z-index: 100;
}

.user-panel {
  clear: left;
  display: block;
  float: left;
}
.user-panel > .image > img {
  width: 100%;
  max-width: 45px;
  height: auto;
}
.user-panel > .info,
.user-panel > .info > a {
  color: #fff;
}
.user-panel > .info > p {
  font-weight: 600;
  margin-bottom: 9px;
}
.user-panel {
  clear: left;
  display: block;
  float: left;
  width: 100%;
  margin-bottom: 15px;
  padding: 25px 15px;
  border-bottom: 1px solid;
}
.user-panel > .info {
  padding: 5px 5px 5px 15px;
  line-height: 1;
  position: absolute;
  left: 55px;
}

.fliph .user-panel {
  display: none;
}
</style>